import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || !GA_MEASUREMENT_ID) return;
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gaOptions: { send_page_view: false },
  });
  initialized = true;
}
